export type OrgShapeCatalogEntry = {
  id:
    | 'org_person_photo'
    | 'org_person_photo_left'
    | 'org_person_photo_right'
    | 'org_person_photo_inner_left'
    | 'org_person_text'
    | 'org_position'
    | 'org_department';
  label: string;
};

export const ORG_PERSON_MATCH_SOURCE_SHAPE_ID = 'org_person' as const;
export const ORG_PERSON_MATCH_SOURCE_SHAPE_LABEL = 'Person Card';

export const ORG_SHAPE_CATALOG: readonly OrgShapeCatalogEntry[] = [
  { id: 'org_person_photo', label: 'Person Card (Photo Top)' },
  { id: 'org_person_photo_left', label: 'Person Card (Photo Left)' },
  { id: 'org_person_photo_right', label: 'Person Card (Photo Right)' },
  { id: 'org_person_photo_inner_left', label: 'Person Card (Inset Photo Left)' },
  { id: 'org_person_text', label: 'Person Card (Text Only)' },
  { id: 'org_position', label: 'Position Card' },
  { id: 'org_department', label: 'Department Card' },
] as const;

export const ORG_SHAPE_IDS = ORG_SHAPE_CATALOG.map((shape) => shape.id);

export const ORG_QUICK_CREATE_SHAPE_IDS = [
  ORG_PERSON_MATCH_SOURCE_SHAPE_ID,
  ...ORG_SHAPE_IDS,
] as const;
